var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#e8eaed",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M493.85-121.54q-79.39-9.69-143.39-41.08-64-31.38-110.11-82.84-46.12-51.46-72.35-120.66-26.23-69.19-30.85-153.73 83.08 2.54 149.08 31.54 66 29 111.96 80.46 45.96 51.47 70.81 124.04 24.85 72.58 24.85 162.27ZM480-362.38q-20.69-35-52.12-69.39-31.42-34.38-64.96-57.77 2.93-38.15 12.7-79.31 9.76-41.15 25.15-80.42 15.38-39.27 35.5-75.42 20.11-36.16 43.73-64.54 23.62 28.38 43.73 64.15 20.12 35.77 35.5 75.81 15.39 40.04 25.54 81.19 10.15 41.16 12.31 80.08-37.39 23.92-69.2 58.31-31.8 34.38-47.88 67.31Zm53.85 230.23q-.47-44.62-8.58-92.58-8.12-47.96-25.35-94.81 39.31-85.61 127.96-143.15 88.66-57.54 194.97-57.16-6.7 148-78.73 244.43Q672.08-179 533.85-132.15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpa);
export default __webpack_public_path__ + "static/media/spa.a74453d0cb9fc4f897da5f61824a2472.svg";
export { ForwardRef as ReactComponent };